(() => {
  const root = document.querySelector('[data-home-slideshow]');
  if (!root) return;
  const slides = [...root.querySelectorAll('[data-home-slide]')];
  if (slides.length < 2) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let index = 0, timer, busy = false, visible = true, paused = reduced.matches;
  const blocked = () => paused || !visible || document.hidden || document.querySelector('[data-agcn-nav].open, dialog[open]');
  const updateMotion = () => {
    root.dataset.homePaused = String(paused);
  };
  const schedule = () => {
    clearTimeout(timer);
    if (!blocked()) timer = setTimeout(change, 3000);
  };
  const change = async () => {
    if (busy) return;
    busy = true;
    clearTimeout(timer);
    let candidate = (index + 1) % slides.length;
    try {
      for (let attempt = 0; attempt < slides.length - 1; attempt++) {
        const photo = slides[candidate].querySelector('img');
        try {
          photo.loading = 'eager';
          await photo.decode();
          slides[index].classList.remove('is-active');
          index = candidate;
          slides[index].classList.add('is-active');
          break;
        } catch (_) { candidate = (candidate + 1) % slides.length; }
      }
    } finally { busy = false; schedule(); }
  };
  document.addEventListener('visibilitychange', schedule);
  new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    schedule();
  }, {root, threshold:.2}).observe(root.querySelector('#intro'));
  const navigation = document.querySelector('[data-agcn-nav]');
  if (navigation) new MutationObserver(schedule).observe(navigation, {attributes:true,attributeFilter:['class']});
  reduced.addEventListener('change', () => { paused = reduced.matches; updateMotion(); schedule(); });
  updateMotion();
  schedule();
})();
